import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';

@Component({
  selector: 'app-request-copy-tab',
  templateUrl: './request-copy-tab.component.html',
  styleUrls: ['./request-copy-tab.component.scss']
})
export class RequestCopyTabComponent implements OnInit, OnChanges {
  @Input()
  RequestCopyTab!: FormGroup;
  @Input()
  sendToSaved!: any;
  @Input()
  StateTypes!: DropdownItem[];
  sendToMode = null;
  @Output() onSendToChanged: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
        console.log(this.sendToSaved);
    if (this.sendToSaved)
        this.sendToMode = this.sendToSaved;
  }

  ngOnInit(): void {
    console.log(this.RequestCopyTab.controls['sendToMode']?.value);
    this.sendToMode = this.RequestCopyTab.controls['sendToMode']?.value;
  }
  onCheck(value: any, event: any) {
    if (!event.checked) value = null;
    this.sendToMode = value;
    this.onSendToChanged.emit(this.sendToMode);
  }
}
